import { RootState } from "src/store";

export const selectKeywordSuggestions = (state: RootState) => 
  state.keywordSuggestions.suggestions;

export const selectKeywordSuggestionsLoading = (state: RootState) => 
  state.keywordSuggestions.loading;

export const selectKeywordSuggestionsError = (state: RootState) => 
  state.keywordSuggestions.error;

export const selectLastSearchedKeyword = (state: RootState) => 
  state.keywordSuggestions.lastSearched;